import { PublicKey } from '@solana/web3.js'

/**
 * Minimal profile shape formerly provided by `@civic/profile`.
 *
 * The `@civic/profile` dependency was removed because its transitive
 * dependency `@bonfida/spl-name-service` was unpublished from npm. Wallet
 * profiles now always resolve to "none", and the Profile components fall back
 * to showing the wallet address (ProfileName) and a placeholder avatar
 * (ProfileImage).
 */
export interface Profile {
  name?: { value: string }
  image?: { url: string }
  headline?: string
  exists: boolean
}

export const useProfile = (
  _publicKey?: PublicKey
): { profile: Profile | undefined; loading: boolean } => {
  return { profile: undefined, loading: false }
}
